import { hourManagementSchema } from './schema';
import HourManagementFormContent from './HourManagementFormContent';
import { useUpdateResource } from 'RestAPIs/useUpdateResource';
import { ADMIN_SETTINGS_GROUP } from 'RestAPIs/endpoints';
import { AdminSettingsFormWrapper } from 'components/shared/AdminSettings/AdminSettingsFormWrapper';
import { useGetAdminSettings } from '../../../../../queries';
import { AdminSettingsResponse } from '../../../../types';
import { convertToSettingsPayload } from '../../Admin/RosterSettings/utils';

const HourManagement = () => {
  const { data: wabData = [], isFetching: isFetchingWab } =
    useGetAdminSettings<AdminSettingsResponse>('wab');
  const { data: hmData = [], isFetching: isFetchingHm } =
    useGetAdminSettings<AdminSettingsResponse>('hour-management');
  const { data: ycData = [], isFetching: isFetchingYc } =
    useGetAdminSettings<AdminSettingsResponse>('year-end-procedure');
  const { data: bbData = [], isFetching: isFetchingBb } =
    useGetAdminSettings<AdminSettingsResponse>('balance-budget');

  const { mutateAsync: saveWab, isLoading: isLoadingWab } = useUpdateResource({
    url: ADMIN_SETTINGS_GROUP,
    id: wabData[0]?.groupId,
    invalidateQueryKey: ['wab']
  });
  const { mutateAsync: saveHm, isLoading: isLoadingHm } = useUpdateResource({
    url: ADMIN_SETTINGS_GROUP,
    id: hmData[0]?.groupId,
    invalidateQueryKey: ['hour-management']
  });
  const { mutateAsync: saveYc, isLoading: isLoadingYc } = useUpdateResource({
    url: ADMIN_SETTINGS_GROUP,
    id: ycData[0]?.groupId,
    invalidateQueryKey: ['year-end-procedure']
  });
  const { mutateAsync: saveBb, isLoading: isLoadingBb } = useUpdateResource({
    url: ADMIN_SETTINGS_GROUP,
    id: bbData[0]?.groupId,
    invalidateQueryKey: ['balance-budget']
  });
  const balanceBudgetAllYears = bbData[0]?.settings.find(
    (s) => s.key === 'balance.budget.depositAllYears'
  );
  const balanceBudgetPlb = bbData[0]?.settings.find(
    (s) => s.key === 'balance.budget.depositPlb'
  );

  const settings =
    isFetchingWab || isFetchingHm || isFetchingYc || isFetchingBb
      ? undefined
      : {
          warningPercentage: { ...wabData[0].settings[0] },
          alertPercentage: { ...wabData[0].settings[1] },
          hourManagementSettingsSchema: [{ ...hmData[0].settings[0] }],
          yearClosureSettingsSchema: {
            ...ycData[0].settings[6],
            value: JSON.parse(ycData[0].settings[6].value)
          },
          balanceBudgetAllYears: {
            ...balanceBudgetAllYears,
            value: balanceBudgetAllYears
              ? JSON.parse(balanceBudgetAllYears.value)
              : false
          },
          balanceBudgetPlb: {
            ...balanceBudgetPlb,
            value: balanceBudgetPlb ? JSON.parse(balanceBudgetPlb.value) : false
          }
        };

  const submitForm = (data) => {
    const wabSettingsData = [data.warningPercentage, data.alertPercentage];
    const wabPayload = convertToSettingsPayload(wabData, wabSettingsData);
    const hmPayload = convertToSettingsPayload(
      hmData,
      data.hourManagementSettingsSchema
    );
    ycData[0].settings[6].value = JSON.stringify(
      data.yearClosureSettingsSchema.value
    );
    const bbPayload = convertToSettingsPayload(bbData, [
      data.balanceBudgetAllYears,
      data.balanceBudgetPlb
    ]);
    Promise.all([
      saveWab(wabPayload),
      saveHm(hmPayload),
      saveYc(ycData[0]),
      saveBb(bbPayload)
    ]);
  };

  return (
    <AdminSettingsFormWrapper
      submitForm={submitForm}
      schema={hourManagementSchema}
      isFetching={isFetchingWab || isFetchingHm || isFetchingYc || isFetchingBb}
      isLoading={isLoadingWab || isLoadingHm || isLoadingYc || isLoadingBb}
      data={settings}
    >
      <HourManagementFormContent />
    </AdminSettingsFormWrapper>
  );
};

export default HourManagement;
